import { maskitoPhoneOptionsGenerator } from '@maskito/phone';
import metadata from 'libphonenumber-js/min/metadata';

export const PHONE_MASK_OPTIONS = maskitoPhoneOptionsGenerator({
  metadata,
  strict: false,
  countryIsoCode: 'RU',
});
